import { render, staticRenderFns } from "./EducationLoader.vue?vue&type=template&id=491393c9"
import script from "./EducationLoader.vue?vue&type=script&lang=js"
export * from "./EducationLoader.vue?vue&type=script&lang=js"
import style0 from "./EducationLoader.vue?vue&type=style&index=0&id=491393c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports